// extracted by mini-css-extract-plugin
export default {"Container":"Carrier_Container__BL27W","Body":"Carrier_Body__m6Rs5","Row":"Carrier_Row__EttPl","RowItem":"Carrier_RowItem__vK6by","Grow":"Carrier_Grow__pjVnk"};